import * as React from 'react'

export function WebBarcodeWrapper() {
    return <div id="web-barcode-reader"></div>
}
